// @ts-nocheck
import styled from 'styled-components';

export const RankingRightPanelStyled = styled.div`
  .mapRankingRightPanel {
    background-color: ${props => props.theme.uiColors.background01} !important;

    .buttonsContainer {
      width: 40px;

      .verticalTabsButton {
        padding: 0;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          color: ${props => props.theme.uiColors.toggleButtonSelectedText} !important;
          background-color: ${props => props.theme.uiColors.toggleButtonSelectedBackground} !important;
        }

        .icon {
          width: auto;
          font-size: ${props => props.theme.fontSizeM};
        }
      }
    }
    .componentContainer {
      box-shadow: 0 -1.3px 13px 0 rgba(18, 22, 30, 0.05);
      width: 313px;

      .componentTitle {
        align-items: center;
        background-color: ${props => props.theme.uiColors.background01};
        color: ${props => props.theme.uiColors.textTitle};
        display: flex;
        font-family: ${props => props.theme.fontSemiBold};
        height: 40px;
        text-transform: none;

        .icon {
          display: none;
        }
      }

      .componentContent {
        background-color: ${props => props.theme.uiColors.backgroundReportingMapPopup};
        box-shadow: 0 -1.3px 13px 0 rgba(18, 22, 30, 0.05);
        overflow: hidden;
        & > div:first-of-type {
          margin-top: 0;
          margin-bottom: 15px;
        }

        & > div:second-of-type {
          background-color: ${props => props.theme.uiColors.background01};
          padding: 8px;
        }

        .reportingInsightsItem__filters {
          margin-top: 0;
        }
        .insightsChartItem__contentWrapper {
          height: calc(100% - 118px);
        }
        .reportingInsightsRankingItem__insightChartItemWrapper{
          height: 100%;
        }
      }
    }
  }
`;
